<template>
  <v-container fluid fill-height class="grey lighten-4" pa-0>
    <v-layout column>
      <scroll-area>
        <template slot="header">
          <v-toolbar dense flat dark color="secondary">
            <v-tooltip dark color="secondary" left>
              <v-btn :data-testid="$options.name + 'v-btn' + 'tstatusdescription'" flat icon :color="status.color" slot="activator">
                <v-icon>lens</v-icon>
              </v-btn>
              <span>{{$t(status.description)}}</span>
            </v-tooltip>
            <v-toolbar-title>
              <v-btn small icon v-if="bar" 
              :data-testid="$options.name + '__btn__' + 'close'"
              @click="()=>{$emit('close')}" color="primary">
                <v-icon>arrow_forward</v-icon>
              </v-btn>
              <span v-if="getData" class="body-2 text-uppercase">{{$t(getData.name)}}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>

        <template slot="body">
          <v-layout column fill-height>
            <v-layout fill-height ma-0>
              <v-flex xs12>
                <v-layout column fill-height class="grey lighten-5">
                  <v-flex xs12 pb-0>
                    <scroll-area>
                      <template slot="body">
                        <v-layout column fill-height justify-start>
                          <v-flex xs12 class="back" pa-1>
                            <v-layout v-if="getPanel" column fill-height class="back darken-1 pa-1" >
                              <equipment-information
                                :data="getSelected"
                                @status="(payload) => checkStatus(payload)"
                              />
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </template>
                    </scroll-area>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </template>
      </scroll-area>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import equipmentInformation from '@/nms/components/equipment/equipment-information.vue'

// Типы
interface StatusItem {
  color: string
  description: string
}

interface StatusesMap {
  [key: string]: StatusItem
}

interface StatusState {
  color: string
  description: string
}

interface DeviceItem {
  $id?: string
  cls?: string
  [key: string]: any
}

interface ActiveEquipmentItem {
  $id?: string
  cls?: string
  [key: string]: any
}

interface EquipmentState {
  activeEquipment: ActiveEquipmentItem[]
  selectedEquipment?: DeviceItem | null
}

interface StoreState {
  equipment: EquipmentState
  devices: {
    activeDevice?: DeviceItem | null
  }
  books: {
    statuses: Array<{
      name: string
      back_color: string
      description?: string
    }>
  }
}

export default Vue.extend({
  name: 'EQUIPMENT_PAGE',

  components: {
    scrollArea,
    equipmentInformation,
  },

  props: {
    bar: {
      type: Boolean,
      default: () => false
    },
  },

  data(): {
    panel: boolean
    device: Record<string, any>
    status: StatusState
    statuses: StatusesMap
  } {
    return {
      panel: false,
      device: {},
      status: {
        color: 'grey',
        description: 'У объекта мониторинга отсутствует сетевая доступность'
      },
      statuses: {},
    }
  },

  computed: {
    getData(): DeviceItem | null {
      const store = this.$store.state as unknown as StoreState
      return store.devices.activeDevice || null
    },

    getSelected(): DeviceItem | null {
      const store = this.$store.state as unknown as StoreState
      const eq = store.equipment.selectedEquipment
      return eq && eq.cls === 'device' ? eq : null
    },

    getPanel(): boolean {
      return this.panel
    },
  },

  watch: {
    '$store.state.equipment.activeEquipment': {
      handler(newVal: ActiveEquipmentItem[]): void {
        console.log('WATCH', this.$options.name, '$store.activeEquipment', newVal)
        if (newVal?.length) {
          this.loadDevice()
          // this.loadStatuses()
          console.log('WATCH', this.$options.name, '$store.activeEquipment', newVal[0].cls)
          this.panel = true
        } else {
          this.panel = false
        }
      },
      deep: true
    },
  },

  created(): void {
    this.loadStatuses()
  },

  mounted(): void {
    document.addEventListener('keyup', this.closeOnESC)
  },

  beforeDestroy(): void {
    document.removeEventListener('keyup', this.closeOnESC)
  },

  methods: {
    async loadDevice(): Promise<void> {
      try {
        const store = this.$store.state as unknown as StoreState
        const activeEquipment = store.equipment.activeEquipment
        const obj$ = await this.$bridge.getObjectById(activeEquipment[0]?.$id)
        
        console.log(this.$options.name, 'loadDevice', 'obj$', obj$)
        if (obj$) {
          console.log(this.$options.name, 'loadDevice', 'obj$', obj$)
          this.$store.dispatch('loadEquipmentDevice', obj$)
        } else {
          this.$store.dispatch('loadEquipmentDevice', null)
          console.log(this.$options.name, 'loadDevice', 'SMTH WRONG', obj$)
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadDevice', 'error', err)
      }
    },

    loadStatuses(): void {
      const store = this.$store.state as unknown as StoreState
      const statuses = store.books.statuses
      
      if (statuses?.length) {
        this.statuses = {}
        statuses.forEach(item => {
          const statusItem: StatusItem = {
            color: item.back_color,
            description: item.description || ''
          }
          this.$set(this.statuses, item.name, statusItem)
          // this.statuses[item.name] = statusItem
        })
      }
    },

    checkStatus(status: { state?: { infoState?: string } }): void {
      if (status?.state?.infoState && this.statuses[status.state.infoState]) {
        this.status = this.statuses[status.state.infoState]
      } else {
        this.status = {
          color: 'grey',
          description: 'У объекта мониторинга отсутствует сетевая доступность'
        }
      }
    },

    closeOnESC(e: KeyboardEvent): void {
      if (e.which === 27 || e.keyCode === 27) {
        e.stopPropagation()
      }
    },

    close(): void {
      this.$emit('close')
    },
  },
})
</script>

<style lang="css" scoped>
</style>
